import { ContentTag } from 'services';
import { getUuidFromIri } from './iri';
import { TagTheme } from '../enum/tag-theme.enum';

export const sortTagsAlphabetically = (tagA: ContentTag, tagB: ContentTag): number => {
    if (tagA.name < tagB.name) {
        return -1;
    }
    if (tagA.name > tagB.name) {
        return 1;
    }

    return 0;
};

export const tagIrisToTags = (iris: string[], allTags: ContentTag[]): ContentTag[] =>
    iris.map(iri => {
        const tagId = getUuidFromIri(iri);
        const contentTag = allTags.find(tag => tag.id === tagId);
        return {
            id: tagId,
            name: contentTag?.name || '',
            theme: contentTag?.theme || TagTheme.THEME_0,
            createdAt: contentTag?.createdAt || '',
            enabled: contentTag?.enabled || false,
        };
    });
